module.exports = __webpack_public_path__ + "static/media/real-time_inventroy.6b7dec67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/real-time_inventroy.svg
// module id = 185
// module chunks = 0